import React, { useRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { homeService } from '../../../services/homeService';

const CTABanner = () => {
  const sectionRef = useRef(null);
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { data: homeContent } = useQuery('homeContent', homeService.get);

  const banners = [
    {
      id: 1,
      title: 'Smart Tracking',
      subtitle:
        'E-Rutu represents the convergence of location tracking and environmental monitoring in a single ruggedized device designed for vehicles, warehouses, and mobile assets. This advanced 4G/2G tracker integrates remote temperature and humidity (RHT) sensing with door status monitoring, providing comprehensive visibility into both asset location and cargo condition. The BLE mobile app configuration enables rapid deployment and on-site adjustments without specialized technical expertise.',
      buttonText: 'LEARN MORE',
      buttonLink: '/services',
      image: '/assets/images/cta1.png',
      textPosition: 'left',
    },
    {
      id: 2,
      title: 'Fleet Management',
      subtitle:
        'Modern fleet operations require intelligent tracking solutions that go beyond simple location reporting to deliver comprehensive vehicle intelligence. E-Vahan combines BLE 5.1 mesh networking with 4G/2G cellular connectivity to create the ultimate vehicle tracking ecosystem for cars, trucks, and specialized equipment. This versatile device supports battery configurations from 330mAh to 10,000mAh, ensuring continuous operation even when primary vehicle power is disconnected or tampered with.',
      buttonText: 'LEARN MORE',
      buttonLink: '/services',
      image: '/assets/images/cta2.png',
      textPosition: 'left',
    },
    {
      id: 3,
      title: 'Sensor Network',
      subtitle:
        "Environmental conditions directly impact product quality, regulatory compliance, and operational efficiency across industries. SiWi's SWRT (SiWi Remote Temperature) sensor delivers precision wireless monitoring of temperature and humidity through Bluetooth 5.1 connectivity, eliminating wiring infrastructure while providing enterprise-grade accuracy. The device measures temperature from -40°C to +80°C and humidity from 0% to 99.99%, covering the full range of commercial and industrial applications.",
      buttonText: 'LEARN MORE',
      buttonLink: '/services',
      image: '/assets/images/cta3.png',
      textPosition: 'right',
    },
    {
      id: 4,
      title: 'Device Manufacturing',
      subtitle:
        "Industrial operations depend on reliable three-phase power supply for critical equipment including refrigeration systems, manufacturing machinery, and emergency generators. SiWi's 3Phase AC Frequency Detector provides wireless monitoring of alternating current presence and power quality, ensuring operational continuity and preventing costly equipment damage. Operating across the 45Hz to 55Hz frequency range, this BLE 5.1 based sensor detects phase loss, voltage fluctuations, and generator status with precision accuracy.",
      buttonText: 'Explore MORE',
      buttonLink: '/services',
      image: '/assets/images/cta4.png',
      textPosition: 'left',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [banners.length]);

  const handleClick = (e, link) => {
    e.preventDefault();

    if (link.includes('#')) {
      if (location.pathname === '/') {
        const sectionId = link.split('#')[1];
        const section = document.getElementById(sectionId);
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(link);
        window.scrollTo(0, 0);
      }
    } else {
      navigate(link);
      window.scrollTo(0, 0);
    }
  };

return (
  <section ref={sectionRef} className="w-full bg-white">
    {/* More top & bottom spacing */}
    <div className="px-[40px] py-[120px]">
      
      {/* Wider container */}
      <div className="max-w-[1600px] mx-auto">
        
        {/* CTA Banner Container - Increased height & no rounded border */}
        <div className="relative h-[700px] w-full overflow-hidden bg-gray-900">
          
          {/* Horizontal Sliding Images */}
          <div
            ref={sliderRef}
            className="absolute inset-0 flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {banners.map((banner) => (
              <div key={banner.id} className="relative h-full w-full flex-shrink-0">
                
                {/* Background Image */}
                <div className="absolute inset-0 w-full h-full">
                  <img
                    src={banner.image}
                    alt={banner.title}
                    className="w-full h-full object-fill"
                    draggable="false"
                  />
                </div>

                {/* Content Overlay */}
                <div className="relative h-full w-full px-8 flex items-center">
                  <div
                    className={`w-full flex ${
                      banner.textPosition === 'right'
                        ? 'justify-end'
                        : 'justify-start'
                    }`}
                  >
                    <div className="max-w-2xl text-center">
                      <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                        {banner.title}
                      </h2>

                      <p className="text-lg text-gray-800 mb-8 line-clamp-3">
                        {banner.subtitle}
                      </p>

                      <button
                        onClick={(e) =>
                          handleClick(e, banner.buttonLink)
                        }
                        className="px-8 py-3 bg-gray-900 text-white font-semibold uppercase tracking-wider text-sm hover:bg-gray-700 transition-all duration-300"
                      >
                        {banner.buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  </section>
);
};

export default CTABanner;